import { RequestService } from '../../services/RequestService';
import { GET_DOCUMENTS_FILL_TYPES } from '../constants';

export const getDocumentsFillTypes = () => {
  return RequestService.get(GET_DOCUMENTS_FILL_TYPES);
};
